import { useState, useEffect } from 'react';
import { useGetAllCandidatesQuery } from '../../../modules/createJob/slice/candiddateApiSlice';
import useDebouncedValue from './useDebouncedValue';
import { useSelector } from 'react-redux';
import { selectJobsItems, selectStagesItems } from '../../../modules/settings/slice/automatedActionsSlice';
import { getDepartmentIds } from '../functions/getDepartmentsIds';
 
function useSearch<T extends Record<string, any>>(searchInput: string, debounceTime = 500) {
    const stages = useSelector(selectStagesItems)
    const jobs = useSelector(selectJobsItems)
    const debouncedSearchInput = useDebouncedValue(searchInput, debounceTime);
    const { data, error, isLoading } = useGetAllCandidatesQuery({
        searchQuery: debouncedSearchInput,
        jobsIds: jobs?.map(({ key }) => key).join(', '),
        pipelineHiringStageIds: stages?.map(({ key }) => key).join(', '),
        departmentIds : getDepartmentIds()
    });

    const [results, setResults] = useState<T[]>([]);
    const [totalCandidatesCount, setTotalCandidatesCounts] = useState<Number>(0);
    useEffect(() => {
        if (data) {
            setResults(data?.data || []);
            setTotalCandidatesCounts(data?.totalSearchCount)
        } else {
            setResults([]);
        }
    }, [data, jobs, stages]);


    return { query: debouncedSearchInput, results, isLoading, error, totalCandidatesCount };
}

export default useSearch;
